//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import api from "@/services/api";
import { server } from "@/services/constants";
import AddProductDialog from "./AddProductDialog.vue";
import Swal from "sweetalert2";
import pdfQuotationGenerator from "@/utils/pdfQuotationGenerator";
import PdfPreviewDialog from "@/components/cards/PdfPreviewDialog";

export default {
    name: "QuotationAdjust",
    components: { AddProductDialog, PdfPreviewDialog },
    data() {
        return {
            pdfBlob: null,
            dialogPDF: false,
            dialogSelectTitle: false,
            dialogSelectClientInfo: "1",
            showAddProductDialog: false,
            addProductPrefill: "",
            addProductTarget: null,
            showVatDetailDialog: false,
            vatDetailType: "fixed",
            rowSeq: 100,
            ADD_NEW_PREFIX: '+ เพิ่ม "',
            ADD_NEW_SUFFIX: '" เป็นสินค้าใหม่',
            dragSrc: null,
            dragOver: null,
            snackbar: { show: false, text: "", color: "success" },

            docType: "fixed",
            doc: {
                quotation_id: null,
                doc_no: "",
                status: "",
                doc_date_show: "",
                client_id: 0,
                client_code: "",
                client_name: "",
                client_address: "",
                tax_id: "",
                branch: "",
                payment_term: "0",
                currency: "THB",
                vat_percent: "7.00",
                attention: "",
                contact_position: "",
                additional_info: "",
                not_to_exceed_cap: "",
            },

            masterItems: [],
            fixedRows: [],
            estimateRows: [],

            print_header_list: [
                {
                    id: "1", com_eng_1: "DEJ-UDOM & ASSOCIATES LTD.", com_eng_2: "ATTORNEYS AT LAW",
                    com_thai: "บริษัท เดชอุดม แอนด์ แอสโซซิเอทส์ จำกัด",
                    com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,", com_add_no: "942/69 RAMA IV ROAD,",
                    com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,", com_add_country: "BANGKOK 10500, THAILAND",
                    com_add_tel: "Tel : 0-2233-0055, 0-2267-5152", com_add_email: "E-MAIL : account@dejudom.com",
                    com_add_tax_id: `TAX ID. No. 0105534015348/"HEAD OFFICE"`,
                    com_display_name: "Dej-Udom & Associates Ltd.",
                },
                {
                    id: "3", com_eng_1: "DEJ-UDOM & ASSOCIATES", com_eng_2: "ATTORNEYS AT LAW",
                    com_thai: "สำนักกฎหมาย เดชอุดม แอนด์ แอสโซซิเอทส์",
                    com_add_name: "CHARN ISSARA TOWER 1, 2nd FLOOR,", com_add_no: "942/69 RAMA IV ROAD,",
                    com_add_city: "KWAENG SURIYAWONG, KHET BANGRAK,", com_add_country: "BANGKOK 10500, THAILAND",
                    com_add_tel: "Tel : 0-2233-0055, 0-2267-5152", com_add_email: "E-MAIL : account@dejudom.com",
                    com_add_tax_id: `TAX ID. No. 0992000028227/"HEAD OFFICE"`,
                    com_display_name: "Dej-Udom & Associates",
                },
            ],
            clientOptions: [],
        };
    },
    computed: {
        statusLabel() {
            return { Submitted: "Submitted", InProgress: "In Progress" }[this.doc.status] || this.doc.status;
        },
        statusColor() {
            return { Submitted: "blue", InProgress: "purple" }[this.doc.status] || "grey";
        },
        fixedTotals() {
            let vatBase = 0, noVatBase = 0, vatAmount = 0, vatCount = 0, noVatCount = 0;
            const rate = Number(this.doc.vat_percent) || 0;
            this.fixedRows.forEach((r) => {
                const lineTotal = (Number(r.qty) || 0) * (Number(r.price) || 0);
                if (r.applyVat) {
                    vatCount += 1;
                    vatBase += lineTotal;
                    vatAmount += lineTotal * (rate / 100);
                } else {
                    noVatCount += 1;
                    noVatBase += lineTotal;
                }
            });
            const total = vatBase + noVatBase;
            return {
                total, vat: vatAmount, grandTotal: total + vatAmount,
                vatBase, noVatBase, vatCount, noVatCount, rowCount: this.fixedRows.length,
            };
        },
        estimateTotals() {
            let vatBase = 0, noVatBase = 0, vatAmount = 0, vatCount = 0, noVatCount = 0;
            const rate = Number(this.doc.vat_percent) || 0;
            this.estimateRows.forEach((r) => {
                const lineTotal = Number(r.rate) || 0;
                if (r.applyVat) {
                    vatCount += 1;
                    vatBase += lineTotal;
                    vatAmount += lineTotal * (rate / 100);
                } else {
                    noVatCount += 1;
                    noVatBase += lineTotal;
                }
            });
            const total = vatBase + noVatBase;
            return {
                total, vat: vatAmount, grandTotal: total + vatAmount,
                vatBase, noVatBase, vatCount, noVatCount, rowCount: this.estimateRows.length,
            };
        },
        allFixedVatSelected() {
            return this.fixedRows.length > 0 && this.fixedRows.every((r) => r.applyVat);
        },
        fixedVatIndeterminate() {
            const checkedCount = this.fixedRows.filter((r) => r.applyVat).length;
            return checkedCount > 0 && checkedCount < this.fixedRows.length;
        },
        allEstimateVatSelected() {
            return this.estimateRows.length > 0 && this.estimateRows.every((r) => r.applyVat);
        },
        estimateVatIndeterminate() {
            const checkedCount = this.estimateRows.filter((r) => r.applyVat).length;
            return checkedCount > 0 && checkedCount < this.estimateRows.length;
        },
        vatDetailRows() {
            const rows = this.vatDetailType === "fixed" ? this.fixedRows : this.estimateRows;
            return rows.map((row) => {
                const base = this.vatDetailType === "fixed"
                    ? (Number(row.qty) || 0) * (Number(row.price) || 0)
                    : (Number(row.rate) || 0);
                const vatAmount = row.applyVat ? base * ((Number(row.vatRate) || 0) / 100) : 0;
                return { name: row.name || "-", base, applyVat: row.applyVat, vatRate: row.vatRate, vatAmount, afterVat: base + vatAmount };
            });
        },
        vatDetailTotals() {
            return this.vatDetailType === "fixed" ? this.fixedTotals : this.estimateTotals;
        },
    },
    async mounted() {
        try {
            await api.checkVersion();
            this.userId = localStorage.getItem(server.USER_ID);
            this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

            if (this.authorize_id == null || this.authorize_id == 0) {
                this.$router.back();
                return;
            }

            const parser = document.createElement("a");
            parser.href = window.location;
            const routerPath = parser.pathname.split("/")[1];
            const resAuth = await api.getAuthorize(this.userId, routerPath);
            const permission = resAuth.data[0];
            if (!permission || permission.smd_edit < 1) {
                this.$router.back();
                return;
            }

            if (!(this.userId && api.isLoggedIn())) {
                this.$store.state.isLogged = false;
                this.$router.push("/login");
                return;
            }
        } catch (error) {
            console.error("QuotationAdjust mounted() auth error:", error);
            this.$store.state.isLogged = false;
            this.$router.push("/login");
            return;
        }

        this.$showLoader();
        try {
            await this.loadCustomer();
            await this.loadMaterProductItem();
            await this.loadQuotationForAdjust(this.$route.params.id);
        } catch (error) {
            console.error("QuotationAdjust mounted() load data error:", error);
            await Swal.fire({
                icon: "error", title: "เกิดข้อผิดพลาด", text: "ไม่สามารถโหลดข้อมูลเอกสารได้ กรุณาลองใหม่อีกครั้ง",
                showConfirmButton: false, timer: 2500, timerProgressBar: true,
            });
        } finally {
            this.$hideLoader();
        }
    },
    methods: {
        async loadCustomer() {
            const result = await api.getAllCustomerListactiveCompany({
                params: { company_id: localStorage.getItem(server.COMPANYID) },
            });
            this.clientOptions = result.data.map((item) => ({
                id: item.id,
                code: item.cust_account,
                name: item.name,
                tax_id: item.taxid,
                branch: item.branch,
            }));
        },
        openVatDetail(type) {
            this.vatDetailType = type;
            this.showVatDetailDialog = true;
        },
        toggleAllVat(type, checked) {
            const rows = type === "fixed" ? this.fixedRows : this.estimateRows;
            rows.forEach((r) => { r.applyVat = checked; });
        },
        getFileName() {
            return `Quotation_${this.doc.doc_no || "Adjust"}.pdf`;
        },
        async loadMaterProductItem() {
            const res = await api.billing_expense_getInvTitleByDep(localStorage.getItem(server.DEPARTMENT_ID));
            this.masterItems = res.data.map((item) => ({ name: item.title, unit: item.unit, rate: Number(item.price) }));
        },
        // ✅ หัวใจของหน้านี้ — โหลดเอกสารแล้วเช็ค status ต้องเป็น Submitted หรือ InProgress เท่านั้น
        async loadQuotationForAdjust(id) {
            const res = await api.billing_expense_getAllQuotationsByID(id);
            const record = res.data;

            if (!record) {
                await Swal.fire({
                    icon: "error", title: "ไม่พบเอกสาร", text: "ไม่พบเอกสารที่ต้องการปรับปรุง",
                    showConfirmButton: false, timer: 2500, timerProgressBar: true,
                });
                this.$router.push("/quotation-list");
                return;
            }

            // ✅ guard สำคัญ: หน้านี้ใช้ได้เฉพาะ Submitted / InProgress เท่านั้น
            if (record.status !== "Submitted" && record.status !== "InProgress") {
                await Swal.fire({
                    icon: "warning", title: "ไม่สามารถปรับปรุงเอกสารนี้ได้",
                    text: "หน้านี้ใช้ได้เฉพาะเอกสารสถานะ Submitted หรือ In Progress เท่านั้น",
                    showConfirmButton: false, timer: 2800, timerProgressBar: true,
                });
                this.$router.push("/quotation-list");
                return;
            }

            // ✅ แทนที่ด้วย: ค้นหาจาก clientOptions
            const clientMatch = this.clientOptions.find(
                (c) => Number(c.id) === Number(record.client_id)
            );

            this.doc = {
                quotation_id: record.quotation_id,
                doc_no: record.doc_no,
                status: record.status,
                doc_date_show: this.formatDocDateShow(record.doc_date),
                client_id: record.client_id,
                client_code: clientMatch ? clientMatch.code : "",
                client_name: clientMatch ? clientMatch.name : (record.client ? record.client.name : `Client #${record.client_id}`),
                client_address: record.client_address,
                tax_id: clientMatch ? clientMatch.tax_id : "",
                branch: clientMatch ? clientMatch.branch : "",
                payment_term: String(record.payment_term ?? "0"),
                currency: record.currency,
                vat_percent: String(record.vat_percent ?? "0"),
                attention: record.attention,
                contact_position: record.contact_position,
                additional_info: record.additional_info,
                not_to_exceed_cap: record.not_to_exceed_cap != null ? String(record.not_to_exceed_cap) : "",
            };

            this.docType = record.doc_type;

            const items = record.items || [];
            if (this.docType === "fixed") {
                this.fixedRows = items.map((item) => ({
                    id: item.item_row_id, name: item.item_name, searchText: "", detail: item.detail || "",
                    qty: item.qty != null ? Number(item.qty) : 0, unit: item.unit || "",
                    price: item.unit_price != null ? Number(item.unit_price) : 0,
                    applyVat: item.apply_vat != null ? !!item.apply_vat : true,
                }));
                this.estimateRows = [];
            } else {
                this.estimateRows = items.map((item) => ({
                    id: item.item_row_id, name: item.item_name, searchText: "", detail: item.detail || "",
                    rate: item.line_total != null ? Number(item.line_total) : "",
                    applyVat: item.apply_vat != null ? !!item.apply_vat : true,
                }));
                this.fixedRows = [];
            }

            const maxId = Math.max(0, ...items.map((i) => i.item_row_id || 0));
            this.rowSeq = Math.max(this.rowSeq, maxId);
        },
        formatDocDateShow(dateOnly) {
            if (!dateOnly) return "";
            const [yyyy, mm, dd] = dateOnly.split("-");
            if (!yyyy || !mm || !dd) return "";
            return `${dd}/${mm}/${yyyy}`;
        },
        fmt(n) {
            return (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        getBackList() {
            this.$router.push("/quotation-list");
        },
        filterMaster(text) {
            const t = (text || "").toString().trim().toLowerCase();
            const original = (text || "").toString().trim();
            if (!t) return this.masterItems.map((m) => m.name);
            const matches = this.masterItems.filter((m) => m.name.toLowerCase().includes(t)).map((m) => m.name);
            if (matches.length === 0 && original) return [`${this.ADD_NEW_PREFIX}${original}${this.ADD_NEW_SUFFIX}`];
            return matches;
        },
        isAddNewItem(item) {
            return typeof item === "string" && item.startsWith(this.ADD_NEW_PREFIX) && item.endsWith(this.ADD_NEW_SUFFIX);
        },
        onNameInput(type, row, val) {
            if (typeof val === "string" && val.startsWith(this.ADD_NEW_PREFIX) && val.endsWith(this.ADD_NEW_SUFFIX)) {
                const typed = val.slice(this.ADD_NEW_PREFIX.length, val.length - this.ADD_NEW_SUFFIX.length);
                row.name = "";
                this.openAddProduct(type, row, typed);
                return;
            }
            row.name = val;
            const found = this.masterItems.find((m) => m.name === val);
            if (found) {
                if (type === "fixed") { row.unit = found.unit; row.price = found.rate; }
                else { row.rate = found.rate; }
            }
        },
        onDetailKeydown(e, type, row) {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                const arr = type === "fixed" ? this.fixedRows : this.estimateRows;
                const idx = arr.findIndex((r) => r.id === row.id);
                const next = arr[idx + 1];
                if (next) {
                    this.$nextTick(() => {
                        const el = document.querySelector(`tr[data-row-id="${type}-${next.id}"] .item-picker input`);
                        if (el) el.focus();
                    });
                } else { this.addRow(type); }
            }
        },
        addRow(type) {
            this.rowSeq += 1;
            if (type === "fixed") {
                this.fixedRows.push({ id: this.rowSeq, name: "", searchText: "", detail: "", qty: 1, unit: "", price: 0, applyVat: true });
            } else {
                this.estimateRows.push({ id: this.rowSeq, name: "", searchText: "", detail: "", rate: "", applyVat: true });
            }
        },
        delRow(type, id) {
            if (type === "fixed") this.fixedRows = this.fixedRows.filter((r) => r.id !== id);
            else this.estimateRows = this.estimateRows.filter((r) => r.id !== id);
        },
        openAddProduct(type, row, prefill) {
            this.addProductTarget = { type, row };
            this.addProductPrefill = prefill || "";
            this.showAddProductDialog = true;
        },
        async onProductSaved(product) {
            if (this.addProductTarget) {
                const { type, row } = this.addProductTarget;
                row.name = product.name;
                row.searchText = product.name;
                if (type === "fixed") { row.unit = product.unit; row.price = product.rate; }
                else { row.rate = product.rate; }
            }
            this.addProductTarget = null;
            try { await this.loadMaterProductItem(); } catch (error) { console.error("loadMaterProductItem error:", error); }
        },
        onDragStart(type, id) { this.dragSrc = { type, id }; },
        onDragOver(type, id) { if (!this.dragSrc || this.dragSrc.type !== type) return; this.dragOver = id; },
        onDrop(type, id) {
            if (!this.dragSrc || this.dragSrc.type !== type || this.dragSrc.id === id) return;
            const arr = type === "fixed" ? this.fixedRows : this.estimateRows;
            const fromIdx = arr.findIndex((r) => r.id === this.dragSrc.id);
            const toIdx = arr.findIndex((r) => r.id === id);
            const [moved] = arr.splice(fromIdx, 1);
            arr.splice(toIdx, 0, moved);
            this.dragSrc = null; this.dragOver = null;
        },
        onDragEnd() { this.dragSrc = null; this.dragOver = null; },
        dragRowClass(type, id) {
            return this.dragOver === id && this.dragSrc && this.dragSrc.type === type ? "drop-target" : "";
        },
        toNullableNumber(val) {
            if (val === "" || val === undefined || val === null) return null;
            const n = Number(val);
            return isNaN(n) ? null : n;
        },
        toNullableString(val) { return val === "" || val === undefined ? null : val; },
        round2(num) { const n = Number(num) || 0; return Math.round((n + Number.EPSILON) * 100) / 100; },

        // ✅ Validation ก่อนบันทึก — เหมือนหน้า Form แต่ไม่เช็ค client_code เพราะเอกสารนี้ผูก client อยู่แล้ว
        validateBeforeSubmit() {
            const rows = this.docType === "fixed" ? this.fixedRows : this.estimateRows;
            if (rows.length === 0) {
                Swal.fire({
                    icon: "error", title: "เกิดข้อผิดพลาด", text: "กรุณาเพิ่มรายการอย่างน้อย 1 รายการ",
                    showConfirmButton: false, timer: 2500, timerProgressBar: true,
                });
                return false;
            }
            return true;
        },

        // ✅ กด Submit ในหน้านี้ — บันทึกข้อมูล แต่ "คง status เดิม" ไว้ ไม่ force เป็น Submitted
        // (เอกสาร InProgress ต้องยังเป็น InProgress ต่อไปหลังปรับปรุง ไม่ถอยสถานะกลับ)
        async onSubmitAdjust() {
            if (!this.validateBeforeSubmit()) return;

            const confirmResult = await Swal.fire({
                icon: "question",
                title: "ยืนยันการบันทึกการปรับปรุง",
                text: "ต้องการบันทึกการแก้ไขเอกสารนี้หรือไม่",
                showCancelButton: true,
                confirmButtonText: "บันทึก",
                cancelButtonText: "ยกเลิก",
            });
            if (!confirmResult.isConfirmed) return;

            var dataItem = {
                doc_type: this.docType,
                status: this.doc.status, // ✅ คง status เดิม (Submitted หรือ InProgress) ไม่เปลี่ยน
                modeUpdate: "updateData",
                client_id: Number(this.doc.client_id),
                client_address: this.doc.client_address,
                payment_term: this.doc.payment_term,
                currency: this.doc.currency,
                vat_percent: Number(this.doc.vat_percent),
                attention: this.doc.attention,
                contact_position: this.doc.contact_position,
                additional_info: this.doc.additional_info,
                subtotal: 0,
                vat_amount: 0,
                grand_total: 0,
                not_to_exceed_cap: 0,
                user_update: Number(localStorage.getItem(server.USER_ID)),
                company_id: Number(localStorage.getItem(server.COMPANYID)),
                department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
            };

            if (this.docType === "fixed") {
                dataItem.subtotal = this.round2(this.fixedTotals.total);
                dataItem.vat_amount = this.round2(this.fixedTotals.vat);
                dataItem.grand_total = this.round2(this.fixedTotals.grandTotal);
            } else {
                dataItem.subtotal = this.round2(this.estimateTotals.total);
                dataItem.vat_amount = this.round2(this.estimateTotals.vat);
                dataItem.grand_total = this.round2(this.estimateTotals.grandTotal);
                dataItem.not_to_exceed_cap = Number(this.doc.not_to_exceed_cap);
            }

            const sourceRows = this.docType === "fixed" ? this.fixedRows : this.estimateRows;
            const itemsPayload = sourceRows.map((row, idx) => {
                const base = {
                    quotation_id: this.doc.quotation_id,
                    seq_no: idx + 1,
                    item_name: row.name || "",
                    detail: this.toNullableString(row.detail),
                    apply_vat: !!row.applyVat,
                };
                if (this.docType === "fixed") {
                    const qty = this.toNullableNumber(row.qty);
                    const unitPrice = this.toNullableNumber(row.price);
                    return { ...base, qty, unit: this.toNullableString(row.unit), unit_price: unitPrice, line_total: this.round2((qty || 0) * (unitPrice || 0)) };
                }
                return { ...base, qty: null, unit: null, unit_price: null, line_total: this.toNullableNumber(row.rate) };
            });

            this.$showLoader();
            try {
                const res_update = await api.billing_expense_updateQuotations(this.doc.quotation_id, dataItem);

                if (res_update.status == 200) {
                    await api.billing_expense_deleteQuotationsItem(this.doc.quotation_id);
                    if (itemsPayload.length > 0) {
                        await api.billing_expense_addQuotationsItem(itemsPayload);
                    }

                    await this.loadQuotationForAdjust(this.doc.quotation_id);
                    this.$hideLoader();

                    await Swal.fire({
                        icon: "success", title: "บันทึกสำเร็จ", text: "ปรับปรุงเอกสารเรียบร้อยแล้ว",
                        showConfirmButton: false, timer: 2000, timerProgressBar: true,
                    });
                }
            } catch (error) {
                console.error("onSubmitAdjust error:", error);
                this.$hideLoader();
                await Swal.fire({
                    icon: "error", title: "เกิดข้อผิดพลาด",
                    text: error.response?.data?.message || "ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
                    showConfirmButton: false, timer: 2500, timerProgressBar: true,
                });
            }
        },

        async onPrint() { this.dialogSelectTitle = true; },
        async confirmPrint() {
            try {
                const selectedCompany = this.print_header_list.find((c) => c.id === this.dialogSelectClientInfo) || this.print_header_list[0];
                const header = {
                    company_inv: "L",
                    com_eng_1: selectedCompany.com_eng_1, com_eng_2: selectedCompany.com_eng_2, com_thai: selectedCompany.com_thai,
                    com_add_name: selectedCompany.com_add_name, com_add_no: selectedCompany.com_add_no,
                    com_add_city: selectedCompany.com_add_city, com_add_country: selectedCompany.com_add_country,
                    com_add_tel: selectedCompany.com_add_tel, com_add_email: selectedCompany.com_add_email,
                    com_add_tax_id: selectedCompany.com_add_tax_id, company_display_name: selectedCompany.com_display_name,
                    doc_no: this.doc.doc_no, doc_type: this.docType,
                    customer_name: this.doc.client_name, customer_address: this.doc.client_address, customer_taxid: this.doc.tax_id,
                    attention: this.doc.attention, payment_term: this.doc.payment_term, currency: this.doc.currency,
                    subtotal: this.docType === "fixed" ? this.fixedTotals.total : this.estimateTotals.total,
                    vat_percent: this.doc.vat_percent,
                    vat_base: this.docType === "fixed" ? this.fixedTotals.vatBase : this.estimateTotals.vatBase,
                    no_vat_base: this.docType === "fixed" ? this.fixedTotals.noVatBase : this.estimateTotals.noVatBase,
                    vat_amount: this.docType === "fixed" ? this.fixedTotals.vat : this.estimateTotals.vat,
                    grand_total: this.docType === "fixed" ? this.fixedTotals.grandTotal : this.estimateTotals.grandTotal,
                    amount_in_words: "", not_to_exceed_cap: this.doc.not_to_exceed_cap, additional_info: this.doc.additional_info,
                };
                const sourceRows = this.docType === "fixed" ? this.fixedRows : this.estimateRows;
                const items = sourceRows.map((row) => ({
                    description: row.name, detail: row.detail,
                    apply_vat: !!row.applyVat,
                    amount: this.docType === "fixed" ? (row.qty || 0) * (row.price || 0) : undefined,
                    rate: this.docType === "estimate" ? this.fmt(row.rate) : undefined,
                }));
                const blob = await pdfQuotationGenerator.exportToPDF({ header, items });
                this.pdfBlob = blob;
                this.dialogSelectTitle = false;
                this.dialogPDF = true;
            } catch (error) {
                this.dialogSelectTitle = false;
                console.error("❌ เกิดข้อผิดพลาดในการสร้าง PDF:", error);
                alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
            }
        },
    },
    async beforeCreate() {
        this.$store.state.navMenu = true;
    },
};
